import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RenderContextComponent } from '../../../../../../../../models/base/render-context-component';
import { GlassHouseBusinessCardStackContentViewModel } from '../glass-house-business-card-stack-content-view-model';

@Component({
  selector: 'app-glass-house-price',
  templateUrl: './glass-house-price.component.html',
  styleUrls: ['./glass-house-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHousePriceComponent extends RenderContextComponent {
  constructor(public viewModel: GlassHouseBusinessCardStackContentViewModel) {
    super();
  }

  setupBindings() {}

  setupViews() {}

  removeDollarSign = (price: string): string => price?.replace('$', '');
}
